module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062934864_Contents#r_idParaDest-6"
    }
  }, [_vm._v("Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("S")]), _vm._v("orry I’m late,” I call as I open the front door at a quarter till nine. “Emergency at work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door to Tommy’s office is closed, which means he’s videoconferencing with a patient somewhere in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dinner smells amazing!” My mouth is watering and I’m glad I only had one slice of pizza at the office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It "), _c('i', [_vm._v("was")]), _vm._v(" amazing,” CeCe says from the living room. “Two hours ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I forgive the saltiness in her voice since I am almost three hours late. “Everything’s a fire drill with this new client.” I walk into the living room and find her curled up in her usual spot on the couch. “I’m sorry I’m so late.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You already said that.” CeCe turns the volume up on whatever cooking competition show she’s watching. I step closer and rest my hand on her shoulder, but she jerks away and stomps upstairs without finding out which chef won.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before scavenging the kitchen for leftovers, I turn off the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("TV and walk back down the hallway toward Tommy’s office. The low murmur of his voice is comforting even though I can’t hear what he’s saying. I lean my head against the door, willing time to move faster so his session will be over and he can cheer me up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If he finds me out here he’ll think I’m trying to eavesdrop again, so I wander back to the kitchen, where I find a mess that’s even scarier than the floor in my half of the bedroom closet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every pot and pan has been used and discarded, lying on the stove or next to the sink. I accept my punishment and start cleaning. The water is almost too hot, but it feels good. The harder I move the scraper back and forth, the more tension leaves my body. This must be why people like working out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m so focused I don’t hear Tommy walk up behind me. I startle when I hear him cough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry,” I say for the thousandth time, turning around to face him. He offers a weak smile and reaches behind me to turn off the water. “You’re not mad at me, too, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not mad,” he says, although his tone implies otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t say you’re disappointed.” I turn back toward the sink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your daughter made something special tonight, she wanted to impress you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was it good?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still is, I bet. We left you a plate in the fridge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sure enough, there’s a foil-wrapped plate sitting on the first shelf. “I honestly don’t get why she cares I wasn’t here, she clearly hates me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t hate you, she’s a teenager.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tried to apologize, but she wouldn’t listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("“She was hurt—which she wouldn’t be if she didn’t love you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess.” I sigh. “Eat dinner with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy pours two glasses of wine while I snap a picture of the plate. I have to admit, it looks like something I’d order in a restaurant. There’s some kind of whitefish, sautéed spinach, and a few tiny roasted potatoes, purple, of course. I find an Instagram filter that makes it look even better and tag CeCe in the caption: "), _c('i', [_vm._v("My daughter, the chef. @WhistlerGurl. #ProudMom #Delicious #ILY.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sad that it’s easier to tell the world I love my daughter in a hashtag than it is for me to say it to her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy sets the glasses down and sits in his usual chair, across from mine and next to CeCe’s. “So there was an emergency at work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t want to hear about it.” I fork a piece of fish. Even cold, it’s good. Really good. “The new chief marketing officer at Dox Pharmacy keeps dangling the business in front of us like a damn carrot. His requests are ridiculous, like he’s trying to see how high we’ll jump.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you keep jumping.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s no other choice. We can’t lose that account—I have seventeen employees counting on me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not the only ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Ouch.")]), _vm._v(" I reach for my wine and take a big sip. When that doesn’t help me feel better, I try to find comfort and understanding in Tommy’s eyes. “I’m trying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to try harder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The edge in his voice catches me off guard. I like it better when he’s soft and supportive, but I know he’s right. He shouldn’t have to handle everything around here. And I can’t "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("even make it home in time to have dinner or a conversation. “You wanted to talk about something last night?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shakes his head and takes a sip of his wine. “It can wait, I’m too tired. Wasn’t an easy day here, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bad patient?” I raise my eyebrow in jest. Trying to get him to spill details about the strangers he counsels is one of my favorite games to play even though I never win.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not bad, but there was one really tough one. This guy just got a terminal diagnosis.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cancer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy nods. “It’s bad. So bad he’s thinking about not doing any treatment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does he have a family?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy nods again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then he has to fight it,” I tell him. “For his family, if not for himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You really think so?” Tommy asks. He looks exhausted. I wish he would talk to me about these things more often. It can’t be healthy to try to carry so many people’s problems alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe he doesn’t want to put his family through a long illness when it’s going to end all the same.” Tommy runs his hands over his head, smoothing hair that isn’t there anymore. “I’m honestly not sure. You weren’t there when my mom was sick. The treatment was worse than the breast cancer—three years of chemo and radiation and surgery, then more chemo and more radiation. She kept fighting past the point her life was worth fighting for, and in the end all that pain and suffering was for nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reach out and take his hand in mine. I hate that I wasn’t there for him when he was losing his mom, almost as much "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("as I hate that Monica was. If I had known, I’d like to think I would have come back sooner. So much happened in the twenty years I was gone, time we’ll never get back.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picking up my fork again, I dredge a baby potato through the lemon butter sauce. “Our daughter is a pretty stellar chef.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s pretty great all around.” Tommy’s eyes light up the way they always do when he talks about CeCe. “She made a pretty good case over the dinner about going to that party this weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not that again.” I stab the last bite of fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So that’s a no?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not if the parents aren’t going to be there.” I drain the rest of my wine. “And by the way, thanks for making me the bad guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know I’ve always had a thing for the bad girls,” Tommy says, smiling with his whole face. Those dimples still get me every time. His foot finds mine beneath the table. “What do you say we leave the dishes for tomorrow and go to bed early?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the best idea I’ve heard all day,” I agree, as he stands and walks around the table toward me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pulls me up and folds me into his arms, kissing me like we haven’t seen each other in days, not hours. Breathless, I step back and look at him looking at me with hungry eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He keeps his hands on my waist as I lead the way upstairs, as if even a step apart would be too far.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before I turn off the bedroom lights, I glance down at my phone. There’s a notification from Instagram that @Whistler Gurl liked my photo.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a30eb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062934864_Chapter_3.vue
// module id = 75
// module chunks = 0